import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DataService } from '../../../../../../services/dashboard/data.service';
import { DmtUtilityService } from '../../../../../../services/dashboard/dmt-utility.service';

@Component({
  selector: 'app-nt-forecast-time-progress',
  imports: [CommonModule],
  templateUrl: './nt-forecast-time-progress.component.html',
  styleUrl: './nt-forecast-time-progress.component.css'
})
export class NtForecastTimeProgressComponent {
  isLoading = false;
  hasData: boolean = false;
  today: Date = new Date();

  public medicineId: number = 0;
  public countryId: number = 1;

  allData: any[] = []; 
  
  constructor (private dataService: DataService, private us: DmtUtilityService) { }

  ngOnInit (): void {
    this.isLoading = true;
    this.today.setHours(0, 0, 0, 0); // reset hours to compare only dates
    this.getSessionVariables();
    this.dataService.regionalAccessInfo(this.medicineId, this.countryId).subscribe(data => {
      // If no data, create placeholder
      // we can simulate empty data with data=[]
      //data=[]
      if (!data || data.length === 0) {
        this.allData = this.createPlaceholderData();
        this.hasData = false;
      } else {
        this.allData = data;
        this.allData.sort((a, b) => a.regionName.localeCompare(b.regionName));
        this.hasData = true;
      }
      
      this.isLoading = false;
    });
  }

  /**
   * Create placeholder data with Italian regions
   */
  private createPlaceholderData(): any[] {
    const regions = [
      'ABRUZZO',
      'BASILICATA',
      'CALABRIA',
      'CAMPANIA',
    ];

    return regions.map(region => ({
      regionName: region,
      dueDate: null,
      endDate: null
    }));
  }

  /** used to remove dash, dots or not numeric characters */
  private normalizeDateString (due: string): string {
    if (!due) return '';
    return due.replace(/[^0-9]/g, '');
  }

  formatDate (due: string): string {
    const cleanDue = this.normalizeDateString(due);
    if (cleanDue.length !== 8) return '---';

    const year = cleanDue.substring(0, 4);
    const month = cleanDue.substring(4, 6);
    const day = cleanDue.substring(6, 8);

    return `${day}/${month}/${year}`;
  }

  compareDates (due: string): number {
    const cleanDue = this.normalizeDateString(due);
    if (cleanDue.length !== 8) return 0;

    const year = parseInt(cleanDue.substring(0, 4), 10);
    const month = parseInt(cleanDue.substring(4, 6), 10) - 1;
    const day = parseInt(cleanDue.substring(6, 8), 10);

    const dueDate = new Date(year, month, day);
    dueDate.setHours(0, 0, 0, 0);

    const delta = Math.round((this.today.getTime() - dueDate.getTime()) / (1000 * 60 * 60 * 24));
    return delta;
  }

  getSessionVariables () {
    this.medicineId = this.us.getSessionVariableNumber('medicineId', 0);
    this.countryId = this.us.getSessionVariableNumber('countryId');
  }
}